import { API_ROUTES } from 'data/ApiRoutes';
import { GET, POST } from 'data/services/api';
import { AxiosResponse } from 'axios';
import { buildApiPath } from 'utils';
import { IAdminDashboardStats } from 'store/intercomSlice';

export const getConversations = async (userId: string) => {
  try {
    const data: AxiosResponse<any> = await GET(
      API_ROUTES.getConversations(userId),
    );
    return data.data;
  } catch (e: unknown) {
    if (typeof e === 'string') {
      throw Error(e.toUpperCase());
    } else if (e instanceof Error) {
      throw Error(e.message);
    }
    throw Error('');
  }
};

export const draftConversationReply = async (userId: string) => {
  try {
    const res: AxiosResponse<any> = await POST(
      API_ROUTES.draftConversationReply(userId),
      {},
    );
    return res.data;
  } catch (e: unknown) {
    if (typeof e === 'string') {
      throw Error(e.toUpperCase());
    } else if (e instanceof Error) {
      throw Error(e.message);
    }
    throw Error('');
  }
};

export interface ConversationSummaryResponse {
  summary: string;
}

// Generated on open and stored nowhere, so there is no GET to read it back —
// the POST is the whole lifecycle.
//
// The caller's AbortSignal only fires when the member changes, the attempt
// changes or the rail unmounts. A route that never settles while the member
// stays selected would leave the section on its skeleton forever, with no
// error and no way forward — worse than a failure, which at least offers Try
// again. This bounds that. It sits ABOVE the backend's own 30s Bedrock
// budget on purpose: when the model stalls, the server's 502 should win and
// produce the specific message, so this catches only a connection where no
// response is coming at all. 45s = that 30s plus headroom for the transcript
// read in front of it, against a generation that normally takes ~4s.
const SUMMARY_TIMEOUT_MS = 45000;

export const summarizeConversation = async (
  userId: string,
  signal?: AbortSignal,
): Promise<ConversationSummaryResponse> => {
  try {
    const res: AxiosResponse<ConversationSummaryResponse> = await POST(
      API_ROUTES.summarizeConversation(userId),
      {},
      { signal, timeout: SUMMARY_TIMEOUT_MS },
    );
    return res.data;
  } catch (e: unknown) {
    if (typeof e === 'string') {
      throw Error(e.toUpperCase());
    } else if (e instanceof Error) {
      throw Error(e.message);
    }
    throw Error('');
  }
};

export const getAdminDashboardStats = async (data: IAdminDashboardStats) => {
  try {
    const res: AxiosResponse<any> = await GET(
      buildApiPath({
        path: API_ROUTES.adminDashboardStats(data.companyId),
        params: {
          companies: data.companies,
          hasBranchCompanies: data.hasBranchCompanies,
          eventType: data.eventType,
        },
      }),
    );
    return res.data;
  } catch (e) {
    if (typeof e === 'string') {
      throw Error(e.toUpperCase());
    } else if (e instanceof Error) {
      throw Error(e.message);
    }
    throw Error('');
  }
};
